import { store } from '../../store';
import { ACCOUNT_INITIALIZE } from '../../store/actions';

const logout = () => {
    console.warn('🚪 Logout automático');

    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');

    store.dispatch({
        type: ACCOUNT_INITIALIZE,
        payload: {
            isLoggedIn: false,
            user: null,
            token: null
        }
    });
};

export default logout;
